import React, { useState, useEffect } from "react";
import SwitchConInput from "./fields/SwitchConInput";
import SwitchConNInput from "./fields/SwitchConNInput";
import ListaToggleButton from "./fields/ListaToggleButton";

const Demolizione = (props) => {
  const [demolizione, setDemolizione] = useState(props.preventivo.demolizione ||

  {
    title: "Demolizione e Rimozione",
    descr: "Sono compresi abbassamento al piano strada delle macerie, carico, trasporto e pagamento oneri di smaltimento alle PPDD",

    // pavimento legno
    rimozionePavimentoLegno: {
      tipologia: "SwitchConInput",
      titolo: "Rimozione Pavimento Legno",
      descrizione: `Demolizione pavimento legno compresa colla`,
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 100,
      //prezzoBase: 50,
      quantitaSoglia: 8,
      prezzoSoglia: 1000,
      totale: 0,
    },

    // pavimento ceramica
    rimozionePavimentoCeramica: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione pavimento ceramica/gres",
      descrizione: `Demolizione pavimento ceramica/gres compresa colla`,
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 9,
      quantitaSoglia: 8,
      prezzoSoglia: 1000,
      totale: 0,
    },

    // pavimento pvc
    rimozionePavimentoPVC: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione pavimento PVC/laminato",
      descrizione: `Demolizione pavimento PVC/laminato compresa colla`,
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 14,
      quantitaSoglia: 8,
      prezzoSoglia: 1000,
      totale: 0,
    },

    // rivestimenti gres
    demolizioneRivestimentoPareteGres: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione rivestimento a parete in ceramica/gres",
      descrizione: `Demolizione di rivestimento a parete in ceramica/gres`,
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 25,
      totale: 0,
    },

    // sottofondo
    demolizioneSottofondo: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione di sottofondo in malta cementizia",
      descrizione: `Demolizione di sottofondo in malta cementizia per permettere una migliore esecuzione degli impianti fino a 5 cm di spessore`,
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 35,
      quantitaSoglia: 8,
      prezzoSoglia: 1000,
      totale: 0,
    },

    // impianto elettrico
    rimozioneImpiantoElettrico: {
      tipologia: "SwitchConInput",
      titolo: "Rimozione impianto elettrico",
      descrizione: `Valutazione iniziale, smontaggio apparecchiature elettriche, rimozione dei cavi elettrici, ispezione e verifica, ripristino delle pareti e dei pavimenti`,
      valore: false,
      descrizioneQuantita: "Numero punti luce",
      descQuantita: "u",
      quantita: 0,
      prezzo: 12,
      totale: 0,
    },

    // impianto idraulico
    rimozioneImpiantoIdraulico: {
      tipologia: "SwitchConInput",
      titolo: "Rimozione impianto idraulico",
      descrizione: ` Valutazione iniziale, smontaggio sanitari,  rimozione impianto idraulico`,
      valore: false,
      descrizioneQuantita: "Numero punti acqua",
      descQuantita: "u",
      quantita: 0,
      prezzo: 60,
      totale: 0,
    },

    // tavolati
    demolizioneTavolati: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione muri tavolati",
      descrizione: "Demolizione di muri tavolati di qualsiasi genere, compresi eventuali intonaci e rivestimenti",
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 45,
      totale: 0,
    },

    // controsoffitti
    demolizioneControSoffitti: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione controsoffitti",
      descrizione: " Demolizione di controsoffitti di qualsiasi tipo, completi di struttura portante",
      valore: false,
      descrizioneQuantita: "Metri quadrati",
      descQuantita: "mq",
      quantita: 0,
      prezzo: 60,
      totale: 0,
    },

    // velette
    demolizioneVelette: {
      tipologia: "SwitchConInput",
      titolo: "Demolizione velette",
      descrizione: "Demolizione di velette di qualsiasi tipo, completi di struttura portante",
      valore: false,
      descrizioneQuantita: "Metri lineari",
      descQuantita: "ml",
      quantita: 0,
      prezzo: 60,
      totale: 0,
    },

    // zoccolino
    rimozioneZoccolino: {
      tipologia: "SwitchConInput",
      titolo: "Rimozione zoccolino",
      descrizione: "Rimozione di zoccolino di qualsiasi tipo (marmo, gres, legno, ...) compresa colla",
      valore: false,
      descrizioneQuantita: "Metri lineari",
      descQuantita: "ml",
      quantita: 0,
      prezzo: 5,
      totale: 0,
    },

    // arredo fisso
    rimozioneArredoFisso: {
      tipologia: "SwitchConInput",
      titolo: "Rimozione arredo ",
      descrizione: "Rimozione arredo composto da elementi di falegnameria ed elementi in vetro",
      valore: false,
      descrizioneQuantita: "Metri lineari",
      descQuantita: "ml",
      quantita: 0,
      prezzo: 60,
      totale: 0,
    },

    // smontaggio porte
    smontaggioPorte: {
      tipologia: "SwitchConInput",
      titolo: "Smontaggio porte interne di ogni tipo",
      descrizione: "Smontaggio di porte interne di ogni tipo (a battente, bilico, doppio battente, ...) e di materiale vario (legno, vetro...), compreso telaio, controtelaio, rivestimento imbottito, eventuali sopraluce",
      valore: false,
      descrizioneQuantita: "Numero Porte",
      descQuantita: "u",
      quantita: 0,
      prezzo: 100,
      totale: 0,
    },

    // smontaggio tubazioni
    rimozioneTubazioni: {
      tipologia: "SwitchConInput",
      titolo: "Rimozioni tubazioni, canali, condotti, griglie e bocchette",
      descrizione: "Rimozioni tubazioni, canali, condotti, griglie e bocchette per il sistema di condizionamento esistente canalizzato. Compresa rimozione di eventuale unità interna nel controsoffitto e ogni altra componente",
      valore: false,
      descrizioneQuantita: "Metri lineari",
      descQuantita: "ml",
      quantita: 0,
      prezzo: 30,
      totale: 0,
    },

  });

  useEffect(() => {
    props.onChange(demolizione);
  }, [demolizione]);

  
    /* divisore*/
  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  );

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2">
          {demolizione.title}
        </div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {demolizione.descr}
        </p>
        <div className="surface-card p-4 shadow-2 border-round">

          <div className="grid formgrid p-fluid">

            {Object.keys(demolizione).map((key) => (
              <React.Fragment key={key}>
                {demolizione[key].tipologia === "SwitchConInput" && (
                  <>
                    <SwitchConInput
                      field={demolizione[key]}
                      onChange={(data) => {
                        setDemolizione({ ...demolizione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {demolizione[key].tipologia === "SwitchConNInput" && (
                  <>
                    <SwitchConNInput
                      field={demolizione[key]}
                      onChange={(data) => {
                        setDemolizione({ ...demolizione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {demolizione[key].tipologia === "ListaToggleButton" && (
                  <>
                    <ListaToggleButton
                      field={demolizione[key]}
                      onChange={(data) => {
                        setDemolizione({ ...demolizione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>

        </div>
      </div>
    </>
  );
};
export default Demolizione;
